export enum EstateUnitStatusEnum {
  active = 'ACTIVE',
  inactive = 'INACTIVE'
}

export interface EstateUnit {
  id: string;
  estateId: string;
  name: string;
  zipcode: string;
  street: string;
  number: string;
  complement?: string;
  district: string;
  city: string;
  state: string;
  observations?: string;
  status: EstateUnitStatusEnum;
  createdAt?: string;
  updatedAt?: string;
}

export interface EstateUnitSummary {
  id: string;
  name: string;
}

export interface CreateEstateUnitPayload {
  estateId: string;
  name: string;
  zipcode: string;
  street: string;
  number: string;
  complement?: string;
  district: string;
  city: string;
  state: string;
  observations?: string;
}

export interface UpdateEstateUnitPayload {
  name?: string;
  zipcode?: string;
  street?: string;
  number?: string;
  complement?: string;
  district?: string;
  city?: string;
  state?: string;
  observations?: string;
}

export interface GetEstateUnitsFilters {
  estateId?: string;
  status?: EstateUnitStatusEnum;
}
